import * as h2Api from '../h2Api'

export const SEARCH_PROFILES = 'CONNECT_SEARCH_ACTIONS_SEARCH'

export const searchProfiles = form => dispatch => {
  return dispatch(h2Api.post('/profiles/search', form)({ type: SEARCH_PROFILES }))
}

export const goals = [
  { id: 1, name: 'Get into college' },
  { id: 2, name: 'Get my HiSET' },
  { id: 3, name: 'Get back into high school' },
  { id: 4, name: 'Work in hospitality' },
  { id: 5, name: 'Work in construction' },
  { id: 6, name: 'Work in technology' },
  { id: 7, name: 'Work in healthcare' },
  { id: 8, name: 'Find a job now' },
  { id: 9, name: 'Be a leader in my community' },
  { id: 10, name: 'Find shelter' }
]

export const criteria = [
  { id: 1, name: 'Are bus accessible' },
  { id: 2, name: 'Pay me to participate' },
  { id: 3, name: 'Are free' },
  { id: 4, name: 'Provide transportation' },
  { id: 5, name: 'Take people under 18' }
]
